import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleUserQuery } from "../../store";
import { CustomTable, MessageBox, MotionDiv, ViewCard } from "../../components";
import { useGetUserAvailabilityQuery } from "../../store/api/users";

const keyProps = {
  Name: "name",
  Email: "email",
  "Phone Number": "phone",
  Role: "role",
  "Company Name": "company_name",
  Designation: "designation",
  "Created At": "created_at",
  "Updated At": "updated_at",
};

const column = ["Date", "Duration"];

const ViewUser = () => {
  const { id } = useParams();

  const [modalShow, setModalShow] = useState(false);
  const { isLoading, isSuccess, error, data } = useGetSingleUserQuery(id);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(5);
  const {
    isLoading: isAvailabilityLoading,
    isFetching: isAvailabilityFetching,
    isSuccess: isAvailabilitySuccess,
    error: availabilityError,
    data: availabilityData,
    isError,
  } = useGetUserAvailabilityQuery({
    id,
    filters: { limit: resultPerPage, page: currentPage },
  });
  const pageHandler = (p) => setCurrentPage(p);

  console.log(data);
  return (
    <>
      <ViewCard
        title={"User Details"}
        data={data?.user}
        setModalShow={setModalShow}
        keyProps={keyProps}
        isImage={true}
        image_url={data?.user?.image}
        reducerProps={{ error, isLoading, isSuccess }}
      >
        {/* <EditModel show={modalShow} onHide={() => setModalShow(false)} />
      {!modalShow && <ToastContainer />} */}
      </ViewCard>
      <MotionDiv>
        {isError ? (
          <MessageBox variant="danger">
            {error?.data?.error?.message}
          </MessageBox>
        ) : (
          <CustomTable
            loading={isAvailabilityFetching}
            column={column}
            rowNo={resultPerPage}
            rowProps={{ setResultPerPage }}
            paging={true}
            pageProps={{
              numOfPages: availabilityData?.totalPages,
              curPage: currentPage,
            }}
            pageHandler={pageHandler}
          >
            {availabilityData?.userAvailability?.length &&
              availabilityData?.userAvailability.map((item, i) => (
                <tr key={i} className="odd">
                  <td>{item.date}</td>
                  <td>{item.duration}</td>
                </tr>
              ))}
          </CustomTable>
        )}
      </MotionDiv>
    </>
  );
};

export default ViewUser;
